import React from 'react';
import TestimonialCard from './TestimonialCard';
import { OuterWrapper, ScrollContainer, BackgroundContainer } from './styledComponents';

export interface TestimonialData {
    name?: string;
    profileImageUrl?: string;
    batch?: string;
    testimonialTitle?: string;
    testimonialDescription?: string;
}

export interface TestimonialsContainerProps {
    testimonials: string;
    className?: string;
    scrollContainerClassName?: string;
}

const TestimonialsContainer: React.FC<TestimonialsContainerProps> = ({
    testimonials,
    className,
    scrollContainerClassName
}) => {
    const testimonialsData = JSON.parse(testimonials);
    return (
        <OuterWrapper
            className={`testimonials-container ${className || ''}`}
        >
            <BackgroundContainer direction="left" />
            <ScrollContainer
                className={`testimonials-scroll ${scrollContainerClassName || ''}`}
            >
                {testimonialsData.map((testimonial: TestimonialData, index: number) => (
                    <TestimonialCard
                        key={index}
                        name={testimonial.name}
                        profileImageUrl={testimonial.profileImageUrl}
                        batch={testimonial.batch}
                        testimonialTitle={testimonial.testimonialTitle}
                        testimonialDescription={testimonial.testimonialDescription}
                    />
                ))}
            </ScrollContainer>
            <BackgroundContainer direction="right" />
        </OuterWrapper>
    );
};

export default TestimonialsContainer;
